/*
 * @description creates the action type dynamically
 * @param {string} entity
 * @param {array} types, used types in the action and reducer files
 * @returns {obj} the object will return with properties of action types, {list: {GET, ERROR, LOADING}, CREATE, DELETE, GET, UPDATE, LOADING, ERROR}
 * */
export function actionTypeGenerator(entity, types = ['list', 'get', 'create', 'update', 'delete']) {
    if (!entity) {
        throw new Error('without entity can\'t create action types');
    }

    let listTypes = {
        get: `${entity}GetList`,
        ...getBaseActions(entity, true)
    };
    let actionTypes = {};
    actionTypes = {...actionTypes, ...getBaseActions(entity)};

    types.forEach(function (type) {
        if (type === 'list') {
            actionTypes['list'] = listTypes;
        } else {
            actionTypes[type] = `${entity}${type.charAt(0).toUpperCase() + type.slice(1)}`;
        }
    });

    return actionTypes;
}

function getBaseActions(entity, is_list = false) {
    return {
        loading: `${entity}IsLoading${is_list ? 'List' : ''}`,
        error: `${entity}Error${is_list ? 'List' : ''}`
    };
}

export function stateGenerator(includeList = true) {
    let state = {
        data: null,
        error: null,
        isLoading: false
    };

    if (includeList) {
        state['list'] = {
            data: null,
            count: 0,
            error: null,
            isLoading: false
        };
    }

    return state;
}
